/**
 * @voltxampere/components — Potentiometer 3-pin component (Sprint 23 B4)
 *
 * Üç terminalli ayarlanabilir direnç (potansiyometre): top — wiper —
 * bottom. `position` parametresi 0..1 aralığında — wiper'in
 * top'a yakınlığını ifade eder:
 *   position = 0 → wiper = top (R_tw = 0, R_wb = R_total)
 *   position = 1 → wiper = bottom (R_tw = R_total, R_wb = 0)
 *   position = 0.5 → wiper merkezde (her iki yarı R/2)
 *
 * Sayısal güvenlik: schema validation `position` değerini
 * (epsilon, 1-epsilon) aralığına sınırlar (varsayılan epsilon=0.001).
 * Tam 0 veya 1 değer kullanıcı isterse stamp tarafında ε-clamp
 * uygulanır (R_tw veya R_wb = 0 → conductance ∞ matrix singüleritesini
 * önlemek için).
 *
 * UI: inspector param tablosunda `position` parametresi için
 * range input slider (Sprint 23 B4 görsel iyileştirme — Şefim'in
 * açık talebi).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { z } from "zod";
const POSITION_EPSILON = 0.001;
export const PotentiometerParamsSchema = z
    .object({
    /**
     * Toplam direnç `R_total` (Ω). Default 10 kΩ — yaygın audio
     * pot referansı.
     */
    resistance: z.number().positive().finite().default(10_000),
    /**
     * Wiper position 0..1. 0 = wiper top'a kaymış (R_top-wiper = 0).
     * 1 = wiper bottom'a kaymış (R_wiper-bottom = 0). Default 0.5
     * (orta).
     */
    position: z
        .number()
        .min(POSITION_EPSILON)
        .max(1 - POSITION_EPSILON)
        .finite()
        .default(0.5),
})
    .strict();
export const potentiometerDefinition = {
    type: "potentiometer",
    category: "passive",
    displayName: { tr: "Potansiyometre", en: "Potentiometer" },
    symbol: "RV",
    pins: [
        { id: "top", side: "left", offset: 0, label: "T" },
        { id: "wiper", side: "right", offset: -10, label: "W" },
        { id: "bottom", side: "right", offset: 10, label: "B" },
    ],
    parameterSchema: PotentiometerParamsSchema,
    nonlinear: false,
};
//# sourceMappingURL=potentiometer.js.map